import { Modal, ModalProps } from "react-bootstrap";
import { useEffect } from "react";
import Check from "../compoment/icon/Check";

interface CartRemovedModalProps extends ModalProps {
  onHide: () => void;
}

const CartRemovedModal = (props: CartRemovedModalProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      props.onHide();
    }, 3000);

    return () => clearTimeout(timer);
  }, [props.onHide]);

  return (
    <Modal
      {...props}
      backdrop="static"
      className="favoriteModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div>
          <div>
            <Check />
          </div>
          <div className="header">Item removed from cart</div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CartRemovedModal;
